import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../config/colores'
import { IconButton, Tooltip } from '@material-ui/core'
import EjectIcon from '@material-ui/icons/Eject'
import LinkBuque from '../components/anunciobuques/LinkBuque'
import OperacionesAnunciosBuques from '../components/anunciobuques/OperacionesAnunciosBuques'
import OperacionesPlanDeEmbarque from '../components/planDeEmbarque/OperacionesPlanDeEmbarque'
import EdicionBuques from '../containers/EdicionBuques'
import PlanDeEmbarque from '../containers/planDeEmbarque/PlanDeEmbarque'
import FechasCargaBuque from '../components/anunciobuques/FechasCargaBuque'

export const EMPLY_LINE_UP_BUQUES = {
  fechaDeArribo: moment(Date.now()).format('DD/MM/YYYY'),
  nombre: null,
  cereal: null,
  toneladas: 0,
  exportador: null,
  agencia: null,
  giro: null,
  paisOrigen: null,
  paisDestino: null
}

export const COLUMNS = [
  {
    name: 'fechaEstimadaDeArribo',
    label: 'Fecha de Arribo',
    options: {
      filter: false,
      sort: false,
      customBodyRender: fechaEstimadaDeArribo => {
        const estado = fechaEstimadaDeArribo.estado
        const fechaD = moment(fechaEstimadaDeArribo.fechaDesde).format('DD/MM/YYYY')
        const fechaH = moment(fechaEstimadaDeArribo.fechaHasta).format('DD/MM/YYYY')
        const vigente = fechaEstimadaDeArribo.vigente
        return (
          fechaEstimadaDeArribo
            ? (estado && estado === 'Cargando')
              ? <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <IconButton style={{ padding: '14px 0' }}>
                  <EjectIcon style={{ color: COLORES.green.light }} />
                </IconButton>
                <p style={{ fontWeight: 'bold' }}>Cargando</p>
              </div>
              : (vigente
                ? ((fechaD === fechaH)
                  ? <div>{fechaD}</div>
                  : <div>{fechaD} - {fechaH}</div>)
                : <>
                  <Tooltip
                    title='Fecha estimada de arribo no vigente'
                  >
                    { ((fechaD === fechaH)
                      ? <div>{fechaD}</div>
                      : <div>{fechaD} - {fechaH}</div>
                    ) }

                  </Tooltip>
                </>
              )
            : null
        )
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'anuncio',
    label: 'Fecha de carga',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (data) => {
        return <FechasCargaBuque data={data} />
      }
    }
  },
  {
    name: 'mesIndex',
    label: ' ',
    options: {
      filter: true,
      filterType: 'checkbox',
      viewColumns: false,
      display: false,
      customBodyRender: v => { return <> </> }
    }
  },
  {
    name: 'nombreBuque',
    label: 'Nombre',
    options: {
      filter: false,
      sort: true,
      customBodyRender: nombreBuque => {
        return <EdicionBuques nombre={nombreBuque.nombreCorto} nombreBuque={nombreBuque.nombre} edicionDesdeAnunciados />
      }
    }
  },
  {
    name: 'exportadores',
    label: 'Exportador/es',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cereales',
    label: 'Cereal/es',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox'
    }
  },
  {
    name: 'toneladasTotal',
    label: 'Toneladas',
    options: {
      filter: false,
      sort: false,
      total: true,
      customBodyRender: (t) => {
        return <>{t > 0 && t} {t <= 0 && ' '} </>
      }
    }
  },
  {
    name: 'nombreAgenciaMaritima',
    label: 'Agencia Marítima',
    options: {
      filter: true,
      sort: false

    }
  },
  {
    name: 'nombreAgenciaDeEstiba',
    label: 'Agencia Estiba',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'giro',
    label: 'Giro',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox',
      customBodyRender: g => {
        const giro = (g === 'GIRO4-5 ') ? '4-5' : (g === 'GIRO6   ' ? '6' : null)
        return <div>{giro}</div>
      }
    }
  },
  {
    name: 'estado',
    label: 'Estado',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox',
      setCellProps: (estado) => {
        return {
          style: (estado === 'Cargando') ? { background: COLORES.green.light, fontWeight: 'bold' } : { background: 'inherit' }
        }
      }
    }
  },
  {
    name: 'fechaAnuncio',
    label: 'Última actualizacion',
    options: {
      filter: false,
      sort: false,
      filterType: 'multiselect',
      customBodyRender: f => {
        if (f !== '') {
          moment.locale('ar-AR')
          const fecha = moment(f).format('DD-MM-YY HH:mm')
          return <div>{fecha}</div>
        } else {
          return null
        }
      }
    }
  },
  {
    name: 'dataBuque',
    label: ' ',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: dataBuque => {
        return <LinkBuque dataBuque={dataBuque} />
      }
    }
  },
  {
    name: 'anuncio',
    label: ' ',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: anuncio => {
        return <OperacionesAnunciosBuques fecha={anuncio.fechaAnuncio} fechaPlanDeEmbarque={anuncio.fechaPlanDeEmbarque} />
      }
    }
  },
  {
    name: 'anuncio',
    label: 'Plan de Embarque',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: anuncio => {
        return (
          <> {anuncio.fechaPlanDeEmbarque
            ? <PlanDeEmbarque anuncio={anuncio} />
            : <OperacionesPlanDeEmbarque anuncio={anuncio} />
          }
          </>
        )
      }
    }
  }
]
